/* @ngInject */
export default function NumberFormatterService() {
    function commaSeparateNumber(number) {
        let parts = number.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
    }

    const si = [
        {value: 1E18, symbol: 'E'},
        {value: 1E15, symbol: 'P'},
        {value: 1E12, symbol: 'T'},
        {value: 1E9, symbol: 'G'},
        {value: 1E6, symbol: 'M'},
        {value: 1E3, symbol: 'k'}
    ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

    function removeUnits(num) {
        let n;
        if (num.endsWith(' uf') || num.endsWith(' pf')) {
            n = num.substring(0, num.length - 3);
        } else if (num.endsWith(' V')) {
            n = num.substring(0, num.length - 2);
        } else {
            n = (' ' + num).slice(1);
        }
        return n;
    }

    function removeCommas(num) {
        return num.replace(/,/g, '');
    }

    function trimNumber(num, digits) {
        const pieces = num.toString().split('.');
        if (pieces.length > 1) {
            pieces[1] = pieces[1].substring(0, digits);
        }
        return pieces.join('.');
    }

    return {
        displayCommaSeparated: commaSeparateNumber,
        shortFormatter: function (num, digits) {
            for (let i = 0; i < si.length; i++) {
                if (num >= si[i].value) {
                    return trimNumber(num / si[i].value, digits).replace(rx, '$1') + si[i].symbol;
                }
            }
            return trimNumber(num, digits).replace(rx, '$1');
        },
        isNumber: function (num) {
            let n = removeUnits(num);
            n = removeCommas(n);
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        parseFloat: function (num) {
            let n = removeUnits(num);
            n = removeCommas(n);
            return parseFloat(n);
        }
    };
}
